module.exports = __webpack_public_path__ + "assets/img/experience-2.d1386d86.svg";